import type {State} from '../../../../../reducers/types'
import {getLocator} from '../../../../../rest/locators'
import {getStatusKey} from '../../../../../rest/schemata'
import {
  getBuildsData,
  getBuildType,
  getShowQueuedBuildsInBuildsList,
  getAutoExpandQueuedBuilds,
  getStatusByKey,
  getIsSakuraUI,
} from '../../../../../selectors'
import {
  getBuildTypeStatusRequest,
  getProjectBuildTypeFilter,
  toBuildTypeId,
} from '../../../../../types'

import type {OwnProps, StateProps} from './BuildTypeHistory.types'

export const mapStateToBuildTypeHistoryProps = (
  state: State,
  {
    buildTypeId = toBuildTypeId(''),
    branch,
    withCollapsedQueued,
    withRunningAndQueued,
    buildState = 'all',
    tag,
    agentPattern,
  }: Partial<OwnProps>,
): StateProps => {
  const shouldLoadRunningAndQueued =
    withRunningAndQueued === true && !['successful', 'failed'].includes(buildState)
  const shouldShowCollapsibleQueuedBuilds = withCollapsedQueued === true && buildState === 'all'
  const statusKey = getStatusKey(getBuildTypeStatusRequest(buildTypeId, branch))
  const status = getStatusByKey(state, statusKey)
  const hasQueued = Boolean(status?.queued)
  const commonLocatorOptions = {
    projectBuildtype: getProjectBuildTypeFilter({
      buildTypeId,
    }),
    withRunningAndQueued: shouldLoadRunningAndQueued,
    branch,
    buildState,
    tag,
    agentPattern,
  }
  const allBuildsLocator = getLocator(commonLocatorOptions)
  const startedBuildsLocator = getLocator({
    ...commonLocatorOptions,
    runningAndFinished: true,
  })
  const {inited, loading, data, ready} = getBuildsData(state, startedBuildsLocator)
  const noStartedBuilds = inited && (!loading || ready) && data.length === 0
  const hasQueuedOnly = hasQueued && noStartedBuilds
  const showQueuedBuilds = shouldShowCollapsibleQueuedBuilds
    ? getShowQueuedBuildsInBuildsList(state) ||
      getAutoExpandQueuedBuilds(state, statusKey) ||
      hasQueuedOnly
    : true
  const locator = showQueuedBuilds ? allBuildsLocator : startedBuildsLocator
  const buildType = getBuildType(state, buildTypeId)
  return {
    withCollapsedQueued: shouldShowCollapsibleQueuedBuilds,
    shouldLoadRunningAndQueued,
    showQueuedBuilds,
    hasQueuedOnly,
    locator,
    internalId: buildType?.internalId,
    isSakuraUI: getIsSakuraUI(state),
    composite: buildType?.type === 'composite',
  }
}
